
	import {IonChip, IonLabel} from "@ionic/vue";

	export default {
		name: "DeleteButton",
		components: {IonChip, IonLabel},
	};
